export default __webpack_public_path__ + "static/media/005-sickle.70cf2227.svg";